export { default } from './PageBlogCategory.vue'
